export function displayMultiSelect(values: string[], filterLabel: string) {
    if (values)
        return values.length > 0
            ? values.length > 1
                ? ` - ${filterLabel}: Many`
                : ` - ${values[0]}`
            : '';
    else //handel nulls
        return '';
}

export function displayObjectMultiSelect(objectValues: any[], propertyName: string, filterLabel: string) {
    if (objectValues)
        return objectValues.length > 0
            ? objectValues.length > 1
                ? ` - ${filterLabel}: Many`
                : ` - ${objectValues[0][propertyName]}`
            : '';
    else //handel nulls
        return '';
}